module.exports = __webpack_public_path__ + "img/user-check.6e743419.svg";